import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import 'react-perfect-scrollbar/dist/css/styles.css'; // Perfect Scrollbar
import './tailwind.css'; // Tailwind CSS
import './i18n'; // i18n configuration
import { RouterProvider } from 'react-router-dom';
import router from './router/index'; // Router setup
import { Provider } from 'react-redux';
import store from './store/index'; // Redux store
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import 'mantine-datatable/styles.layer.css';
import { AuthProvider } from './components/Layouts/context/Authcontext';
import { StartDateTimeProvider } from './components/Layouts/context/StartDateTimeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MantineProvider>
    <React.StrictMode>
      <AuthProvider>
        <StartDateTimeProvider>
          <Suspense>
            <Provider store={store}>
              <RouterProvider router={router} />
            </Provider>
          </Suspense>
        </StartDateTimeProvider>
      </AuthProvider>
    </React.StrictMode>
  </MantineProvider>
);
